import { render, staticRenderFns } from "./TableTextItem.vue?vue&type=template&id=01e9d2b7&scoped=true"
import script from "./TableTextItem.vue?vue&type=script&lang=js"
export * from "./TableTextItem.vue?vue&type=script&lang=js"
import style0 from "./TableTextItem.vue?vue&type=style&index=0&id=01e9d2b7&scoped=true&lang=css"
import style1 from "./TableTextItem.vue?vue&type=style&index=1&id=01e9d2b7&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e9d2b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01e9d2b7')) {
      api.createRecord('01e9d2b7', component.options)
    } else {
      api.reload('01e9d2b7', component.options)
    }
    module.hot.accept("./TableTextItem.vue?vue&type=template&id=01e9d2b7&scoped=true", function () {
      api.rerender('01e9d2b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/tableItems/TableTextItem.vue"
export default component.exports